<router-outlet />
<app-toast />
<app-upload-progress></app-upload-progress>
@if (showJournalFab) {
  <app-contemplation-floating-dictation></app-contemplation-floating-dictation>
}
@if (showUserMessenger) {
  <app-coaching-messenger></app-coaching-messenger>
}
@if (showCoachUnreadDock) {
  <app-coaching-unread-dock></app-coaching-unread-dock>
}